import http from '@/utils/http';

export default {
	reviewList: data => http({ url: '/api/admin/v1/invoice/reviewList', data }),
	reviewItem: data => http({ url: '/api/admin/v1/invoice/reviewItem', data, tip: true }),
	carrierPending: data => http({ url: '/api/admin/v1/invoice/carrierPending', data }),
	recordCarrierInvoice: data => http({ url: '/api/admin/v1/invoice/recordCarrierInvoice', data, tip: true }),
	detail: data => http({ url: '/api/admin/v1/invoice/detail', data }),
	confirmItem: data => http({ url: '/api/admin/v1/invoice/confirmItem', data, tip: true }),
	completeItem: data => http({ url: '/api/admin/v1/invoice/completeItem', data, tip: true }),
	uploadFile: data => http({ url: '/api/admin/v1/invoice/uploadFile', data, files: true }),
};
